module.exports = __webpack_public_path__ + "static/media/web_page_buy.d03f870c.png";